import { render, staticRenderFns } from "./AddAdverts.vue?vue&type=template&id=9a17b5a2&scoped=true"
import script from "./AddAdverts.vue?vue&type=script&lang=js"
export * from "./AddAdverts.vue?vue&type=script&lang=js"
import style0 from "./AddAdverts.vue?vue&type=style&index=0&id=9a17b5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a17b5a2",
  null
  
)

export default component.exports